import { createFileRoute, useParams } from '@tanstack/react-router';
import { IndividualContractDetailView } from '@/pages/contract/individual-contract/individual-contract-detail-view.tsx';

export const Route = createFileRoute('/_auth/einzelvertrag/$individualContractId')({
  component: RouteComponent,
});

function RouteComponent() {
  const { individualContractId: individualContractIdParam } = useParams({
    from: '/_auth/einzelvertrag/$individualContractId',
  });

  const individualContractId = Number(individualContractIdParam);
  if (!Number.isFinite(individualContractId)) {
    return <div>Ungültige ID: {individualContractIdParam}</div>;
  }
  return <IndividualContractDetailView individualContractId={individualContractId} />;
}
